import { db } from '../DBUtils';
import { ITaxonomy } from '../interfaces/ITaxonomy';

export type ActivityList = {
	activities: ITaxonomy[];
	success: boolean;
	reason?: string;
};

export class ActivityFactory {
	public static getEmpty() {
		const empty_set: ActivityList = {
			activities: [],
			success: true,
		};
		return empty_set;
	}

	public static async getAll() {
		return db.activities
			.toArray()
			.then(async (my_activities) => {
				let retval: ActivityList = {
					activities: my_activities,
					success: true,
				};
				return retval;
			})
			.catch((reason) => {
				let retval: ActivityList = {
					activities: [],
					success: false,
					reason: reason,
				};
				return retval;
			});
	}
}
